// extracted by mini-css-extract-plugin
export default {"entityTypeToggle":"EntityTypeToggle_entityTypeToggle__icJ0F","iconContainer":"EntityTypeToggle_iconContainer__iQFMR"};